<template>
    <div>
        {{$t('common.systemName')}} ©2020 All Rights Reserved.
    </div>
</template>
<script>
export default {
    name: 'Footer',
}
</script>